<div class="add-alert-layout">
  <h1>{{ addEditPageTitle }}</h1>

  <form #alertForm (submit)="onSubmitAlertForm()">
    <h3>1.Item type</h3>
    <label class="form-group full-width">
      <span [ngbPopover]="alertTypeContent" triggers="hover" placement="right">
        Which type of customised item would you like to create?
        <ng-template #alertTypeContent>
          <div [innerHTML]="alertCopy.type | safe: 'html'"></div>
        </ng-template>
      </span>
      <span class="select-layer">
        <select
          class="app-select"
          name="action"
          (change)="onActionChange($event.target.value)"
          [(ngModel)]="alert.action"
        >
          <option value="99" disabled selected hidden>please select</option>
          <option value="0">an alert</option>
          <option value="2">a custom paragraph</option>
          <option value="1">a custom letter</option>
        </select>
      </span>
    </label>

    <div [ngClass]="{ hidden: alert.action.toString() === '99' }">
      <h3>2.Audit trail (optional)</h3>
      <label class="form-group">
        <span [ngbPopover]="alertClientName" triggers="hover" placement="right">
          Name of client who ordered this:
        </span>
        <ng-template #alertClientName>
          <div [innerHTML]="alertCopy.clientName | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <input
            aria-label=""
            class="app-input"
            name="orderingClient"
            placeholder="John"
            type="text"
            [(ngModel)]="alert.orderingClient"
          />
        </span>
      </label>
      <label class="form-group">
        <span [ngbPopover]="alertWhenOrdered" triggers="hover" placement="left">
          When ordered:
        </span>
        <ng-template #alertWhenOrdered>
          <div [innerHTML]="alertCopy.whenOrdered | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <p-calendar
            class="primeng-date"
            [(ngModel)]="whenOrdered"
            placeholder="11/11/2017 11:07 PM"
            showTime="true"
            hourFormat="12"
            dateFormat="dd/mm/yy"
            name="whenOrdered"
          ></p-calendar>
        </span>
      </label>
      <label class="form-group">
        <span [ngbPopover]="alertHowOrdered" triggers="hover" placement="right">
          How ordered:
        </span>
        <ng-template #alertHowOrdered>
          <div [innerHTML]="alertCopy.howOrdered | safe: 'html'"></div>
        </ng-template>
        <span class="select-layer">
          <select class="app-select" name="howOrderedId" [(ngModel)]="alert.howOrderedId">
            <option value="0" disabled selected hidden>please select</option>
            <option value="1">by email</option>
            <option value="2">by phone</option>
            <option value="3">by letter</option>
            <option value="4">in person</option>
          </select>
        </span>
      </label>
      <label class="form-group">
        <span [ngbPopover]="alertReceivingPerson" triggers="hover" placement="left">
          Person who received the order:
        </span>
        <ng-template #alertReceivingPerson>
          <div [innerHTML]="alertCopy.receivingPerson | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <input
            aria-label=""
            class="app-input"
            name="receivingPerson"
            placeholder="John"
            type="text"
            [(ngModel)]="alert.receivingPerson"
          />
        </span>
      </label>

      <h3>3.Item details</h3>
      <label class="form-group">
        <span [ngbPopover]="alertId" triggers="hover" placement="right"> ID number: </span>
        <ng-template #alertId>
          <div [innerHTML]="alertCopy.idNumber | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <input
            aria-label=""
            class="app-input hidden-input"
            name="idNumber"
            type="text"
            [(ngModel)]="alert.id"
            disabled
          />
        </span>
      </label>
      <label class="form-group">
        <span [ngbPopover]="name" triggers="hover" placement="left">
          Name (50 characters max)*:
        </span>
        <ng-template #name>
          <div [innerHTML]="alertCopy.alertName | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <input
            aria-label=""
            class="app-input"
            name="alertName"
            placeholder="Alert name"
            type="text"
            [(ngModel)]="alert.name"
            required
          />
        </span>
      </label>
      <div class="label info red" *ngIf="formErrorField === 'name'">Please insert alert name!</div>
      <label class="form-group">
        <span [ngbPopover]="alertStartDate" triggers="hover" placement="right"> Start date*: </span>
        <ng-template #alertStartDate>
          <div [innerHTML]="alertCopy.startDate | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <p-calendar
            class="primeng-date"
            [(ngModel)]="startDate"
            placeholder="05/05/2018"
            dateFormat="dd/mm/yy"
            name="startDate"
            required
          ></p-calendar>
        </span>
      </label>
      <label class="form-group">
        <span [ngbPopover]="alertEndDate" triggers="hover" placement="left"> End date: </span>
        <ng-template #alertEndDate>
          <div [innerHTML]="alertCopy.endDate | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <p-calendar
            class="primeng-date"
            [(ngModel)]="endDate"
            placeholder="11/07/2018"
            dateFormat="dd/mm/yy"
            name="endDate"
          ></p-calendar>
        </span>
      </label>
      <div class="label info red" *ngIf="formErrorField === 'start-date'">
        Please select a start date!
      </div>
      <label class="form-group">
        <span [ngbPopover]="alertInstructions" triggers="hover" placement="right">
          Instructions to users:
        </span>
        <ng-template #alertInstructions>
          <div [innerHTML]="alertCopy.instructions | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <textarea (change)="alert.instructions = $event.target.value" class="app-textarea">{{
            alert.instructions
          }}</textarea>
        </span>
      </label>

      <!--letter extra fields-->
      <label class="form-group" *ngIf="alert.action.toString() === '1'">
        <span [ngbPopover]="alertLetterType" triggers="hover" placement="left">
          Letter - type:
        </span>
        <ng-template #alertLetterType>
          <div [innerHTML]="alertCopy.letterType | safe: 'html'"></div>
        </ng-template>
        <span class="select-layer">
          <select class="app-select" name="letterType" [(ngModel)]="alert.letterTypeId">
            <option value="0" disabled selected hidden>please select</option>
            <option value="2">RM letter using my decision and explanation</option>
            <option value="1">custom letter entirely</option>
          </select>
        </span>
      </label>
      <label
        class="form-group"
        *ngIf="alert.action.toString() === '1' && alert.letterTypeId.toString() === '2'"
      >
        <span [ngbPopover]="alertLetterDecision" triggers="hover" placement="right">
          Letter - decision:
        </span>
        <ng-template #alertLetterDecision>
          <div [innerHTML]="alertCopy.letterDecision | safe: 'html'"></div>
        </ng-template>
        <span class="select-layer">
          <select class="app-select" name="letterDecision" [(ngModel)]="alert.decisionId">
            <option value="0" disabled selected hidden>please select</option>
            <option value="1">Uphold</option>
            <option value="2">Cancel</option>
            <option value="3">Request info</option>
          </select>
        </span>
      </label>
      <label
        class="form-group"
        *ngIf="alert.action.toString() === '1' && alert.letterTypeId.toString() === '2'"
      >
        <span [ngbPopover]="alertLetterExplanation" triggers="hover" placement="left">
          Letter - explanation:
        </span>
        <ng-template #alertLetterExplanation>
          <div [innerHTML]="alertCopy.letterExplanation | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <textarea (change)="alert.explanation = $event.target.value" class="app-textarea">{{
            alert.explanation
          }}</textarea>
        </span>
      </label>
      <label
        class="form-group"
        *ngIf="
          alert.action.toString() === '1' &&
          alert.letterTypeId.toString() === '2' &&
          alert.decisionId.toString() === '3'
        "
      >
        <span [ngbPopover]="alertLetterProof" triggers="hover" placement="right">
          Letter - proof text:
        </span>
        <ng-template #alertLetterProof>
          <div [innerHTML]="alertCopy.letterProof | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <input
            aria-label=""
            class="app-input"
            name="letterProof"
            placeholder="Letter proof"
            type="text"
            [(ngModel)]="alert.proofText"
          />
        </span>
      </label>
      <label
        class="form-group"
        *ngIf="alert.action.toString() === '1' && alert.letterTypeId.toString() === '1'"
      >
        <span [ngbPopover]="alertLetterEntire" triggers="hover" placement="right">
          Letter - entire text:
        </span>
        <ng-template #alertLetterEntire>
          <div [innerHTML]="alertCopy.letterEntire | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <textarea (change)="alert.explanation = $event.target.value" class="app-textarea">{{
            alert.explanation
          }}</textarea>
        </span>
      </label>
      <label
        class="form-group full-width"
        *ngIf="alert.action.toString() === '1' && alert.letterTypeId.toString() === '1'"
      >
        <span [ngbPopover]="alertProgressionCase" triggers="hover" placement="right">
          Progression for the case:
        </span>
        <ng-template #alertProgressionCase>
          <div [innerHTML]="alertCopy.progressionCase | safe: 'html'"></div>
        </ng-template>
        <!-- <select2 [options]="casesList" class="app-select app-select2 select2-case" name="progressionCase"
          [settings]="select2OptionsCase" (onSelect)="onSelectCases($event)" [(ngModel)]="selectedCases"></select2> -->

        <p-dropdown
          [options]="casesList"
          [(ngModel)]="selectedCountry"
          optionLabel="text"
          [filter]="true"
          filterBy="text"
          [showClear]="true"
          placeholder="Enter the progression case..."
        >
          <ng-template pTemplate="selectedItem" let-selectedOption>
            <div class="flex align-items-center gap-2">
              <span>{{ selectedOption.id }}</span>
            </div>
          </ng-template>
          <ng-template let-state pTemplate="item">
            <div class="flex align-items-center gap-2">
              <span
                ><strong class="text-gold">{{ state.id }}</strong> {{ state.text }}
              </span>
            </div>
          </ng-template>
        </p-dropdown>
      </label>

      <!--paragraph extra fields-->
      <label class="form-group" *ngIf="alert.action.toString() === '2'">
        <span [ngbPopover]="alertParagraphText" triggers="hover" placement="left">
          Paragraph text:
        </span>
        <ng-template #alertParagraphText>
          <div [innerHTML]="alertCopy.paragraphText | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <textarea (change)="alert.explanation = $event.target.value" class="app-textarea">{{
            alert.explanation
          }}</textarea>
        </span>
      </label>
      <label class="form-group" *ngIf="alert.action.toString() === '2'">
        <span [ngbPopover]="alertParagraphPlace" triggers="hover" placement="right">
          Place custom paragraph:
        </span>
        <ng-template #alertParagraphPlace>
          <div [innerHTML]="alertCopy.paragraphPlace | safe: 'html'"></div>
        </ng-template>
        <span class="select-layer">
          <select class="app-select" name="paragraphPlace" [(ngModel)]="alert.paragraphLocationId">
            <option value="0" disabled selected hidden>please select</option>
            <option value="1">at the start of the explanation section</option>
            <option value="2">at the end of the explanation section</option>
            <option value="3">after the explanation produced by the reason(s) in 4 below</option>
          </select>
        </span>
      </label>
      <label class="form-group" *ngIf="alert.action.toString() === '2'">
        <span [ngbPopover]="alertParagraphAuto" triggers="hover" placement="left">
          Select this paragraph automatically:
        </span>
        <ng-template #alertParagraphAuto>
          <div [innerHTML]="alertCopy.selectParagraph | safe: 'html'"></div>
        </ng-template>
        <span class="question-label checkbox" [ngClass]="{ selected: alert.paragraphAutoSelect }">
          <input
            aria-label=""
            type="checkbox"
            [checked]="alert.paragraphAutoSelect"
            (change)="alert.paragraphAutoSelect = !alert.paragraphAutoSelect"
          />
        </span>
      </label>
    </div>

    <div *ngIf="alert.id !== ''">
      <div>
        <h3 class="inline-block" [ngbPopover]="alertTriggers" triggers="hover" placement="right">
          4.Triggers. Show/offer this to users if:
        </h3>
      </div>
      <ng-template #alertTriggers>
        <div [innerHTML]="alertCopy.triggers | safe: 'html'"></div>
      </ng-template>

      <label class="form-group" *ngIf="!rmOnline">
        <span> The PCN was issued between: </span>
        <span class="input-layer">
          <p-calendar
            class="primeng-date"
            [(ngModel)]="issuedStartDate"
            placeholder="05/05/2018"
            dateFormat="dd/mm/yy"
            name="issuedStartDate"
          ></p-calendar>
        </span>
      </label>
      <label class="form-group" *ngIf="!rmOnline">
        <span> And: </span>
        <span class="input-layer">
          <p-calendar
            class="primeng-date"
            [(ngModel)]="issuedEndDate"
            placeholder="05/05/2018"
            dateFormat="dd/mm/yy"
            name="issuedEndDate"
          ></p-calendar>
        </span>
      </label>

      <label class="form-group">
        <span [ngbPopover]="alertPcnNumber" triggers="hover" placement="right">
          The PCN number is:
        </span>
        <ng-template #alertPcnNumber>
          <div [innerHTML]="alertCopy.pcnNumbers | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <textarea (change)="alert.pcnNumbers = $event.target.value" class="app-textarea">{{
            alert.pcnNumbers
          }}</textarea>
        </span>
      </label>

      <label class="form-group" *ngIf="!rmOnline">
        <!--<span [ngbPopover]="alertPcnLocation" triggers="hover" placement="left">-->
        <span> The PCN location is: </span>
        <!--<ng-template #alertPcnLocation>
          <div [innerHTML]="alertCopy.pcnNumbers | safe: 'html'"></div>
        </ng-template>-->
        <span class="input-layer">
          <textarea (change)="alert.locations = $event.target.value" class="app-textarea">{{
            alert.locations
          }}</textarea>
        </span>
      </label>
      <label class="form-group" [ngClass]="{ 'right-align': rmOnline }">
        <span [ngbPopover]="alertContravention" triggers="hover" placement="right">
          The contravention is:
        </span>
        <ng-template #alertContravention>
          <div [innerHTML]="alertCopy.contravention | safe: 'html'"></div>
        </ng-template>
        <span class="input-layer">
          <textarea (change)="alert.contraventions = $event.target.value" class="app-textarea">{{
            alert.contraventions
          }}</textarea>
        </span>
      </label>
      <label class="form-group" *ngIf="!rmOnline">
        <!--<span [ngbPopover]="alertVrm" triggers="hover" placement="left">-->
        <span> The VRM is: </span>
        <!--<ng-template #alertVrm>
          <div [innerHTML]="alertCopy.contravention | safe: 'html'"></div>
        </ng-template>-->
        <span class="input-layer">
          <textarea
            (change)="alert.registrationNumbers = $event.target.value"
            class="app-textarea"
            >{{ alert.registrationNumbers }}</textarea
          >
        </span>
      </label>
      <div class="form-group inline-block">
        <span [ngbPopover]="alertStage" triggers="hover" placement="right" class="darker">
          The stage is:
        </span>
        <ng-template #alertStage>
          <div [innerHTML]="alertCopy.stage | safe: 'html'"></div>
        </ng-template>
        <label
          class="question-label checkbox"
          *ngFor="let pcnStage of pcnStages"
          [ngClass]="{
            selected: pcnStage.checked,
            disabled: isStageCheckboxEnable(pcnStage.value)
          }"
        >
          <span>{{ pcnStage.name }}</span>
          <input
            aria-label=""
            type="checkbox"
            [checked]="pcnStage.checked"
            (change)="pcnStage.checked = !pcnStage.checked"
            [disabled]="isStageCheckboxEnable(pcnStage.value)"
          />
        </label>
      </div>
      <div class="form-group inline-block">
        <span [ngbPopover]="alertPcnType" triggers="hover" placement="left" class="darker">
          The PCN type is:
        </span>
        <ng-template #alertPcnType>
          <div [innerHTML]="alertCopy.pcnType | safe: 'html'"></div>
        </ng-template>
        <label
          class="question-label checkbox"
          *ngFor="let pcnType of pcnTypes"
          [ngClass]="{ selected: pcnType.checked }"
        >
          <span>{{ pcnType.name }}</span>
          <input
            aria-label=""
            type="checkbox"
            [checked]="pcnType.checked"
            (change)="pcnType.checked = !pcnType.checked"
          />
        </label>
      </div>
      <label class="form-group full-width">
        <span [ngbPopover]="alertReasonSelected" triggers="hover" placement="right">
          The reason selected is:
        </span>
        <ng-template #alertReasonSelected>
          <div [innerHTML]="alertCopy.reasonSelected | safe: 'html'"></div>
        </ng-template>
        <!-- <select2 [options]="reasonsList" class="app-select app-select2 select2-reason" name="reasonSelected"
          [settings]="select2OptionsReason" (onSelect)="onSelectReasons($event)" [(ngModel)]="selectedReasons">
        </select2> -->
          <select2
            [data]="reasonSearchData"
            [value]="value"
            multiple="true"
            (update)="onSelectReasons($event)"
            (search)="onReasonsSearch($event)"
            hideSelectedItems="true"
            
            name="reasons-select"
            id="inputReasons"
            [(ngModel)]="selectedReasons"
            placeholder="Search for reasons..."
            customSearchEnabled
          >
          
          </select2>
          <button type="submit" style="display: none"></button>
        <!-- <p-multiSelect [options]="reasonsList" [(ngModel)]="selectedReasons" placeholder="Search for reasons..." optionLabel="text">
          <ng-template let-value pTemplate="selectedItems">
            <div class="inline-flex align-items-center gap-2 px-1" *ngFor="let state of value">
              <span>{{ state.text }}</span>
            </div>
          <div *ngIf="!value || value.length === 0">progression case...</div> 
          </ng-template>
          <ng-template let-state pTemplate="item">
            <div class="flex align-items-center gap-2">
              <span
                ><strong class="text-gold">{{ state.text }}</strong> {{ state.additional }}
              </span>
            </div>
          </ng-template>
        </p-multiSelect> -->
      </label>
      <label class="form-group full-width">
        <span [ngbPopover]="alertDocumentSelected" triggers="hover" placement="right">
          The document selected is:
        </span>
        <ng-template #alertDocumentSelected>
          <div [innerHTML]="alertCopy.documentSelected | safe: 'html'"></div>
        </ng-template>
        <!-- <select2 [options]="documentsList" class="app-select app-select2 select2-document" name="documents"
          [settings]="select2OptionsDocument" (onSelect)="onSelectDocuments($event)" [(ngModel)]="selectedDocuments">
        </select2> -->
          <select2
            [data]="documentsSearchData"
            [value]="value"
            multiple="true"
            (update)="onSelectDocuments($event)"
            (search)="onDocumentsSearch($event)"
            hideSelectedItems="true"
            
            name="documents"
            id="inputDocuments"
            [(ngModel)]="selectedDocuments"
            placeholder="Search for documents..."
            customSearchEnabled
          >
          
          </select2>
          <button type="submit" style="display: none"></button>
        <!-- <p-multiSelect
          [options]="documentsList"
          [(ngModel)]="selectedDocuments"
          placeholder="Search for documents..."
          optionLabel="text"
        >
          <ng-template let-value pTemplate="selectedItems">
            <div class="inline-flex align-items-center gap-2 px-1" *ngFor="let state of value">
              <span>{{ state.text }}</span>
            </div>
            <div *ngIf="!value || value.length === 0">progression case...</div> 
          </ng-template>
          <ng-template let-state pTemplate="item">
            <div class="flex align-items-center gap-2">
              <span
                >{{ state.text }}
                <span class="text-gold">
                  in <strong>{{ state.additional }}</strong></span
                ></span
              >
              <span
                ><strong class="text-gold">{{ state.id }}</strong> {{ state.text }}
              </span>
            </div>
          </ng-template>
        </p-multiSelect> -->
      </label>
      <label class="form-group full-width">
        <span [ngbPopover]="alertPolicy" triggers="hover" placement="right">
          The policy being called is:
        </span>
        <ng-template #alertPolicy>
          <div [innerHTML]="alertCopy.policy | safe: 'html'"></div>
        </ng-template>
        <!--<select2 [options]="policiesList" class="app-select app-select2 select2-policy"
               name="policies" [settings]="select2OptionsPolicy"
               (onSelect)="onSelectPolicies($event)" [(ngModel)]="selectedPolicies"></select2>-->
        <span (click)="openPoliciesPanel(policiesModal)" class="add-policy"> Check policies </span>
      </label>
    </div>

    <ng-template #policiesModal let-c="close" let-d="dismiss">
      <div class="modal-container policies-modal">
        <div class="close-icon black medium" (click)="d('Cross click')"></div>
        <div class="content">
          <h4>Select the policy/ies which will trigger the item you're setting up.</h4>

          <div class="policies-container box-shadow">
            <div class="categories">
              <div
                class="category"
                *ngFor="let section of policies"
                [ngClass]="{ active: selectedPolicyCat === section.categoryId }"
                (click)="selectPolicyCategory(section)"
              >
                <span [ngClass]="{ active: numOfSelectedPolicies(section) > 0 }">
                  <span>
                    {{ section.categoryName }}
                    <span
                      class="number-bubble"
                      [@bounceBubble]="numOfSelectedPolicies(section)"
                      *ngIf="numOfSelectedPolicies(section) > 0"
                    >
                      {{ numOfSelectedPolicies(section) }}
                    </span>
                  </span>
                </span>
              </div>
            </div>
            <div class="policies" *ngIf="visiblePolicieSection.policies !== undefined">
              <div class="question-block" *ngFor="let policy of visiblePolicieSection.policies">
                <p-accordion>
                  <p-accordionTab class="accordion-tab">
                    <p-header
                      class="question-label checkbox"
                      [ngClass]="{ selected: isPolicySelected(policy.id) }"
                    >
                      <i
                        class="checkbox-placeholder"
                        (click)="selectPolicy(policy.id); stopPropagation($event); (false)"
                      ></i>
                      <h5 [innerHTML]="policy.text"></h5>
                    </p-header>
                    <div class="answers" *ngIf="policy.type === 'radio'">
                      <div class="question-block" *ngFor="let answer of policy.answers">
                        <div
                          class="question-label radio"
                          [ngClass]="{ selected: answer.isChecked }"
                        >
                          <i class="radio-icon"></i>
                          <span [innerHTML]="answer.text"></span>
                        </div>
                      </div>
                    </div>
                    <div class="checkbox-select" *ngIf="policy.type === 'select'">
                      <input
                        aria-label=""
                        class="select-input"
                        type="text"
                        [value]="policy.answers.text"
                        disabled
                      />
                    </div>
                    <div class="answers" *ngIf="policy.type === 'checkbox'">
                      <div class="question-block" *ngFor="let answer of policy.answers">
                        <div
                          class="question-label checkbox disabled"
                          [ngClass]="{ selected: answer.isChecked }"
                        >
                          <i class="checkbox-placeholder"></i>
                          <span [innerHTML]="answer.text"></span>
                        </div>
                      </div>
                    </div>
                    <div class="answers" *ngIf="policy.type === 'input'">
                      <input
                        aria-label=""
                        class="app-input policy-input"
                        type="text"
                        [value]="policy.answer.value"
                        disabled
                      />
                    </div>
                    <div class="answers" *ngIf="policy.type === 'currency'">
                      <span class="currency-sign">&#163;</span>
                      <input
                        aria-label=""
                        class="app-input policy-input currency"
                        type="text"
                        [value]="policy.answer.value"
                        disabled
                      />
                    </div>
                  </p-accordionTab>
                </p-accordion>
              </div>
              <div class="question-block" *ngIf="visiblePolicieSection.policies.length === 0">
                {{ visiblePolicieSection.placeholder }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <span class="submit-layer">
      <input aria-label="" type="submit" class="app-submit" [value]="isEditPage ? 'Save' : 'Add'" />
    </span>
  </form>
</div>
